import React from 'react'

const About: React.FC = () => {
  return (
    <section className="ls hello s-pt-50 s-pt-lg-100 s-pt-xl-150 c-mb-30 c-gutter-60">
      <div className="container" id="about">
        <div className="row">
          <div className="col-12 col-md-5 d-block">
            <picture>
              <source
                srcSet="/images/main_page_welcome.webp"
                type="image/webp"
              />
              <source srcSet="/images/main_page_welcome.jpg" type="image/jpg" />
              <img src="/images/main_page_welcome.jpg" alt="Ada Borek, Registered Aesthetic Nurse at Ada Aesthetics in Cheshunt - Level 7 qualified aesthetic practitioner" />
            </picture>
          </div>
          <div className="col-md-7 col-12">
            <div className="divider-60 d-none d-xl-block"></div>
            <div className="title-section text-center text-md-left">
              <span className="sub-title absolute-subtitle">welcome</span>
              <h1 className="special-heading">
                Transform Your Confidence with Natural-Looking Aesthetic Treatments in Cheshunt
              </h1>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <p className="text-center text-md-left">
                  Welcome to Ada Aesthetics, a leading aesthetic clinic in
                  Cheshunt, Hertfordshire. Our mission is to deliver
                  natural-looking, results-focused treatments so your
                  skin looks like itself – only better. Led by Ada Borek, a Registered Aesthetic
                  Nurse with Level 7 qualifications and over 10 years of medical
                  experience, we ensure every client receives safe, professional
                  care tailored to their unique needs.
                </p>
                <p className="text-center text-md-left">
                  We specialise in advanced facial aesthetics including{' '}
                  <strong><a href="/anti-wrinkle-injections-cheshunt">Anti-Wrinkle Injections (Botox)</a></strong>,{' '}
                  <strong><a href="/lip-fillers">lip fillers</a></strong>, <strong><a href="/cheek-fillers">cheek fillers</a></strong>,{' '}
                  <strong><a href="/dermal-fillers-cheshunt">dermal fillers</a></strong>, and the popular{' '}
                  <strong><a href="/russian-lips">Russian lips</a></strong> technique. Whether you're
                  looking to smooth fine lines, add volume to your lips, or
                  restore youthful contours, our personalised approach ensures
                  natural-looking results that enhance your features and boost
                  your confidence.
                </p>
                <p className="text-center text-md-left">
                  Conveniently located in Cheshunt, Waltham Cross, we proudly
                  serve clients from across Hertfordshire and beyond, including
                  Hoddesdon, Broxbourne, Enfield, Waltham Abbey, Hertford, and
                  North London. Our comfortable, private clinic offers a
                  welcoming environment where you can relax and discuss your
                  aesthetic goals during a complimentary consultation.
                </p>

                <h2 className="content-section-heading text-center text-md-left">
                  Our Aesthetic Treatments in Cheshunt
                </h2>
                <p className="text-center text-md-left">
                  At Ada Aesthetics, we offer a comprehensive range of{' '}
                  <strong>aesthetic treatments</strong> designed to enhance your natural beauty.
                  Our most popular treatments include <strong><a href="/botox-cheshunt">Botox injections</a></strong> for smoothing
                  wrinkles and fine lines, <strong><a href="/dermal-fillers-cheshunt">dermal fillers</a></strong> for restoring facial volume,
                  and the renowned <strong><a href="/russian-lips">Russian lips technique</a></strong> for beautifully shaped,
                  heart-shaped lips. We also provide <strong><a href="/cheek-fillers">cheek fillers</a></strong>, <strong><a href="/tear-trough-filer">tear trough
                  fillers</a></strong> for under-eye rejuvenation, <strong><a href="/fat-dissolving">fat dissolving injections</a></strong>,
                  and <strong><a href="/dermaplaning">dermaplaning</a></strong> for glowing skin.
                </p>
                <p className="text-center text-md-left">
                  For those seeking beauty treatments, we specialize in <strong><a href="/eyebrows-lamination-and-tint">brow lamination
                  and tinting</a></strong>, <strong><a href="/lash-lift-and-tint">lash lift and tint</a></strong>, and <strong>HD Brows</strong>
                  to frame your face beautifully. Every treatment is performed with precision and care,
                  using only premium, licensed products to ensure your safety and satisfaction.
                </p>

                <h2 className="content-section-heading text-center text-md-left">
                  Why Choose Ada Aesthetics in Cheshunt?
                </h2>
                <ul className="text-left" style={{ marginLeft: '20px' }}>
                  <li><strong>Trusted by 500+ Clients:</strong> 5-star rated on Google, Booksy, and Treatwell - our clients love their natural results</li>
                  <li><strong>Experienced & Qualified:</strong> Ada Borek is a Registered Aesthetic Nurse with Level 7 qualifications and over 10 years of medical experience</li>
                  <li><strong>Natural-Looking Results:</strong> We focus on enhancing your natural beauty, not changing it - expect subtle, refreshed results</li>
                  <li><strong>Premium Products:</strong> We use only licensed, high-quality products including Revolax fillers and premium botulinum toxin</li>
                  <li><strong>Personalized Care:</strong> Every treatment is tailored to your unique facial structure and aesthetic goals</li>
                  <li><strong>Free Consultations:</strong> Discuss your concerns and receive expert advice with no obligation</li>
                  <li><strong>Competitive Pricing:</strong> Professional treatments from £45, with transparent pricing and no hidden costs</li>
                  <li><strong>Convenient Location:</strong> Easily accessible clinic in Cheshunt serving Waltham Cross, Broxbourne, Hertfordshire, and North London</li>
                </ul>

                <h2 className="content-section-heading text-center text-md-left">
                  Book Your Free Consultation Today
                </h2>
                <p className="text-center text-md-left">
                  Ready to discover how aesthetic treatments can help you look and feel your best?
                  Join 500+ satisfied clients who trust us for natural-looking results. Whether you are interested in{' '}
                  <strong><a href="/botox-cheshunt">Botox in Cheshunt</a></strong>, <strong><a href="/lip-fillers">lip
                  fillers</a></strong>, <strong><a href="/anti-wrinkle-injections-cheshunt">anti-wrinkle injections</a></strong>, or any of our beauty
                  treatments, we are here to help. <strong>Limited availability - book today to secure your preferred time</strong>.
                  Call us at <strong><a href="tel:07478705252">07478705252</a></strong> or
                  reserve your complimentary consultation online (worth £50).
                </p>
              </div>
              <div className="col-lg-12">
                <p className="text-center text-md-center">
                  <strong>
                    Ada Aesthetics: Professional facial aesthetics you can
                    trust.
                  </strong>
                </p>
                <p className="text-center text-md-center">
                  <i>
                    "Let me use my years of clinical experience to help you look
                    and feel your best."
                  </i>
                </p>
              </div>
            </div>
            <div className="divider-40 d-none d-xl-block"></div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
